import React from 'react';

import isPropValid from '@emotion/is-prop-valid';
import { StyleSheetManager, ThemeProvider } from 'styled-components';

import GlobalStyle from './fonts';
import { variables } from './variables';

// Custom prop filter that always allows className to be forwarded
// This fixes issues with BEM classNames not being applied to styled-components
const shouldForwardProp = (prop) => prop === 'className' || isPropValid(prop);

const Theme = ({ children }) => {
  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      <ThemeProvider theme={{ colors: variables.colors, responsive: variables.responsive }}>
        <GlobalStyle />
        {children}
      </ThemeProvider>
    </StyleSheetManager>
  );
};

export default Theme;
